
      var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconTv = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2.8,
  y: 2.8,
  width: 18.4,
  height: 14.4,
  rx: 1.2,
  stroke: "#414045",
  strokeWidth: 1.6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 21h6",
  stroke: "#414045",
  strokeWidth: 1.6,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m12.237 12.414 1.972 1.248c.252.16.565-.077.49-.372l-.57-2.24a.342.342 0 0 1 .111-.347l1.768-1.471c.232-.194.112-.58-.186-.598l-2.309-.15a.33.33 0 0 1-.283-.21l-.861-2.168a.325.325 0 0 0-.608 0L10.9 8.275a.33.33 0 0 1-.283.209l-2.309.15c-.298.019-.418.404-.186.598l1.768 1.471c.1.085.143.22.11.347l-.527 2.078c-.09.353.285.638.588.446l1.832-1.16a.32.32 0 0 1 .344 0z",
  stroke: "#414045",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <rect x=\"2.8\" y=\"2.8\" width=\"18.4\" height=\"14.4\" rx=\"1.2\" stroke=\"#414045\" stroke-width=\"1.6\"/>\r\n    <path d=\"M9 21h6\" stroke=\"#414045\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n    <path clip-rule=\"evenodd\" d=\"m12.237 12.414 1.972 1.248c.252.16.565-.077.49-.372l-.57-2.24a.342.342 0 0 1 .111-.347l1.768-1.471c.232-.194.112-.58-.186-.598l-2.309-.15a.33.33 0 0 1-.283-.21l-.861-2.168a.325.325 0 0 0-.608 0L10.9 8.275a.33.33 0 0 1-.283.209l-2.309.15c-.298.019-.418.404-.186.598l1.768 1.471c.1.085.143.22.11.347l-.527 2.078c-.09.353.285.638.588.446l1.832-1.16a.32.32 0 0 1 .344 0z\" stroke=\"#414045\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-tv.e915552f282a98aa50f57adc863b0111.svg"),
        {
          React: SvgIconTv,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      